import {
    INDIVIDUAL_SELECT_ITEM,
    INDIVIDUAL_CLEAR
} from '../constants/individual-action-types'
  
  export const individualSelectItem = (selectedFile, action, keyCollection = "") => {
    return dispatch => {
      dispatch({
        type: INDIVIDUAL_SELECT_ITEM,
        payload: {
          selectedFile: selectedFile,
          action: action,
          keyCollection: keyCollection,
        }
      })
    }
  }
  export const individualClear = () => {
    return dispatch => {
      dispatch({
        type: INDIVIDUAL_CLEAR,
      })
    }
  }
  